import * as Action from "@actions/index";
import * as Model from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class Type {
  public static async load() {
    useDispatch(Action.Stand.Type.setStatus("loading"));
    try {
      const response = await new Model.Stand().types();
      useDispatch(Action.Stand.Type.setGroups(response.data));
      let list: any = [];
      response.data.forEach((Group: any) => {
        list = list.concat(Group.itemList);
      });
      useDispatch(Action.Stand.Type.setList(list));
      useDispatch(Action.Stand.Type.setStatus("loaded"));
      return response.data;
    } catch (Exception) {}
  }
}
